import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import "bootstrap/dist/css/bootstrap.css"
import './index.css';
import './theme.css';
import Routes from './components/Routes'
import '@fortawesome/fontawesome-free/css/all.min.css';

// Interceptor global: garantiza que `error.response.data` SIEMPRE exista.
// Casi todos los catch del sistema hacen `error.response.data`; ante un error
// de red/timeout/CORS `error.response` es undefined y ese acceso revienta con
// un TypeError DENTRO del catch, ocultando el error real y dejando la pantalla
// colgada. Aquí lo normalizamos a un mensaje legible.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) {
      error.response = {
        status: 0,
        data:
          error.code === "ECONNABORTED"
            ? "El servidor tardó demasiado en responder. Intenta de nuevo."
            : "Sin conexión con el servidor. Revisa tu internet o si el sistema está en mantenimiento.",
      };
    } else if (error.response.data === undefined || error.response.data === null) {
      error.response.data = `Error ${error.response.status}`;
    }
    return Promise.reject(error);
  }
);

let tema = localStorage.getItem("tema")

if(tema == "white-content"){
  document.body.classList.add("white-content")
}

ReactDOM.render(
  <React.StrictMode>
    <Routes />
  </React.StrictMode>,
  document.getElementById('root')
);

